var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBgChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2276 1435",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.484 903.438c-57.717-34.887-57.173-118.792.993-152.927L1302.15 12.451c30.75-18.051 69.32-15.997 97.99 5.22l839.27 621.156c53.09 39.286 46.4 120.668-12.39 150.761L986.946 1424.41a88.997 88.997 0 01-86.594-3.05L43.484 903.438z",
    fill: "url(#bg_chart_svg__paint0_linear_1996_16513)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg_chart_svg__paint0_linear_1996_16513",
    x1: 201.481,
    y1: 922.707,
    x2: 1275.28,
    y2: 292.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF2FF",
    stopOpacity: 0
  })))));
}

export default SvgBgChart;